// extracted by mini-css-extract-plugin
module.exports = {"TemplateLabel":"classes_TemplateLabel__3ZM0p","TemplateLabelMin":"classes_TemplateLabelMin__32Bna","CalendarInputDate":"classes_CalendarInputDate__Q4OLs"};